import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import BlockRouter from '../components/BlockRouter';
import GradientWrapper from '../components/GradientWrapper';
import HelmetMichelberger from '../components/HelmetMichelberger';
import Information from '../components/Information';
import RestaurantSchema from '../components/RestaurantSchema';
import Layout from '../components/Layout';
import PageTitle from '../components/PageTitle';
import PageDescription from '../components/PageDescription';


const RestaurantPage = ({ data, location, pageContext }) => {
  const { languageSwitch } = pageContext;
  const {
    body, description, gradient, infoButtonLabel, infoButtonUrl, infoText, name, seoMetaTags,
  } = data.allDatoCmsRestaurant.edges[0].node;
  const footerData = data.allDatoCmsFooter.edges[0].node;

  return (
    <Layout languageSwitch={languageSwitch} location={location} pageContext={pageContext}>
      <GradientWrapper footerData={footerData} gradient={gradient} languageSwitch={languageSwitch}>
        <HelmetMichelberger seo={seoMetaTags} />
        <RestaurantSchema />
        <PageTitle>{name}</PageTitle>
        <PageDescription isSmall>{description}</PageDescription>
        <Information buttonLabel={infoButtonLabel} buttonUrl={infoButtonUrl} text={infoText} />
        <For each="block" index="index" of={body}>
          <BlockRouter key={block.id} block={block} index={index} />
        </For>
      </GradientWrapper>
    </Layout>
  );
};

RestaurantPage.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
};

export default RestaurantPage;

export const query = graphql`
  query RestaurantPage($locale: String!) {
    allDatoCmsRestaurant(filter: { locale: { eq: $locale } }) {
      edges {
        node {
          gradient {
            color {
              hex
            }
          }
          name
          description
          infoButtonLabel
          infoButtonUrl
          infoText
          ...GatsbyDatoCmsRestaurantBody
          seoMetaTags {
            ...GatsbyDatoCmsSeoMetaTags
          }
        }
      }
    }
    allDatoCmsFooter(filter: { locale: { eq: $locale } }) {
      edges {
        node {
          ...footerFields
        }
      }
    }
  }
`;
